// test2257
(2257 && 0);
